import { createStandardAction } from "typesafe-actions";
import { Page } from "../Page";

export const changePage = createStandardAction("CHANGE_PAGE")<Page>();



// WEBPACK FOOTER //
// ./src/actions/navActions.ts